export default {
    namespace: 'locale',
    state: {
        LOCALE_SYSTEM: {},
        LOCALE_HTML: {},
        LOCALE_REQUEST: {},
        LOCALE_EDITOR: {},
        antdLocale: null
    },
    reducers: {
        update(state, { payload: { locale } }) {
            let TEXT
            let antdLocale = null
            try {
                if (locale === 'en') {
                    TEXT = require(`../config/locale/en_US`).default
                } else if (locale === 'tw') {
                    TEXT = require(`../config/locale/zh_TW`).default
                } else {
                    TEXT = require(`../config/locale/${locale}`).default

                    // 阿拉伯语
                    if (locale === 'ar_EG') {
                        document.querySelector('html').dir = 'rtl'
                        document.querySelector('html').lang = 'ar'
                    }
                }
            } catch (error) {
                TEXT = require(`../config/locale/zh_CN`).default
            }

            // url传入en参数时特殊处理
            const antd_lan = locale === 'en' ? 'en_US' : locale
            try {
                if (locale === 'en') {
                }
                antdLocale =
                    require(`antd/lib/locale-provider/${antd_lan}`).default
            } catch (error) {
                antdLocale = require(`antd/lib/locale-provider/zh_CN`).default
            }

            return {
                LOCALE_SYSTEM: TEXT.LOCALE_SYSTEM,
                LOCALE_HTML: TEXT.LOCALE_HTML,
                LOCALE_REQUEST: TEXT.LOCALE_REQUEST,
                LOCALE: locale,
                antdLocale,
                LOCALE_EDITOR: TEXT.LOCALE_EDITOR
            }
        }
    }
}
